export interface PaymentForm {
  id: string;
  type: string;
}

export const noCardsForm: Array<PaymentForm> = [
  {
    id: '5',
    type: 'Boleto',
  },
  {
    id: '675',
    type: 'Pix',
  },
  {
    id: 'pix',
    type: 'Pix',
  },
];
